/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { DeploymentUnitOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Button } from '@/primitives/Button';
import { Card } from '@/primitives/Card';
import { Flex } from '@/primitives/Flex';
import { Text } from '@/primitives/Text';
import { Title } from '@/primitives/Title';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';

export function NoNodesEmptyState() {
  const { t } = useMimicTranslation('noNodes');
  const navigate = useNavigate();
  const selectedTenantID = useMgmtPlaneStateStore((state) => state.selectedTenantID);

  return (
    <Card style={{ width: '100%', marginTop: 24 }} padding="xxl">
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%', padding: '48px 24px' }}>
        <Flex vertical align="center" gap="md">
          <div
            style={{
              fontSize: 80,
              opacity: 0.15,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 16,
            }}
          >
            <DeploymentUnitOutlined />
          </div>
          <Title level={3} style={{ margin: 0, textAlign: 'center' }}>
            {t('title')}
          </Title>
          <Text type="subtle" size="lg" style={{ textAlign: 'center', maxWidth: 400 }}>
            {t('subtitle')}
          </Text>
          <Button
            type="primary"
            icon={<DeploymentUnitOutlined />}
            onClick={() => navigate(`/tenants/${selectedTenantID}/node-releases/windows`)}
            style={{ marginTop: 16, height: 40, paddingLeft: 24, paddingRight: 24 }}
          >
            {t('downloadNode')}
          </Button>
        </Flex>
      </div>
    </Card>
  );
}
